import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  Form,
  FloatingLabel,
  Container,
  Table,
  Modal,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faX } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
// import { BedTypeServices } from "../../services/BedType";
import { LoadingModal } from "../components/LoadingModal";

function EditSSTeamModal({
  show,
  onHide,
  // sstTeam
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //SST Team multiple input start
  const [sstTeamArray, setSstTeamArray] = useState([]);
  const [sstTeamInputData, setSstTeamInputData] = useState({
    sstTeam: "",
  });

  // Function to handle input change
  const sstTeamInputChange = (e) => {
    setSstTeamInputData({
      ...sstTeamInputData,
      sstTeam: e.target.value,
    });
  };

  // Function to add input data
  const addsstTeamInputData = () => {
    if (sstTeamInputData.sstTeam.trim() !== "") {
      setSstTeamArray([...sstTeamArray, sstTeamInputData]);
      setSstTeamInputData({ sstTeam: "" });
    } else {
      // Notify user that the input field should not be empty
      alert("Field should not be empty");
    }
  };

  // Function to delete data
  const deletesstTeamData = (index) => {
    const updatedArray = sstTeamArray.filter((item, i) => i !== index);
    setSstTeamArray(updatedArray);
  };
  //SST Team myltiple input end

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Team
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="input-modal-spacing">
          <div className="input-modal-spacing">
            <FloatingLabel controlId="name" label="Team Name*" className="mb-3">
              <Form.Control type="text" placeholder="Team Name*" />
            </FloatingLabel>
            <Row>
              <Col>
                <FloatingLabel
                  controlId="sstTeamMembers"
                  label="MOs*"
                  className="mb-3"
                  style={{ marginRight: "1rem" }}
                >
                  <Form.Control
                    type="text"
                    placeholder="MOs"
                    className="text-capitalize"
                    value={sstTeamInputData.sstTeam}
                    onChange={sstTeamInputChange}
                  />
                </FloatingLabel>
              </Col>
              <Col>
                <Button
                  onClick={addsstTeamInputData}
                  style={{ height: "40px" }}
                  className="custom-btn-reverse"
                >
                  Add
                </Button>
              </Col>
            </Row>
            <Container style={{ paddingRight: "8rem", marginLeft: "-1rem" }}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Team Members</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {sstTeamArray.map((item, index) => (
                    <tr key={index}>
                      <td>{item.sstTeam}</td>
                      <td>
                        <FontAwesomeIcon
                          icon={faX}
                          onClick={() => deletesstTeamData(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {/* <p className="required-field-meassage">
                  {addError.staySstTeamDetails}
                </p> */}
            </Container>
          </div>
        </Modal.Body>
        <hr className="color-grey" />
        <Row className="modal-button-group-spacing">
          <Col className="modal-add-button-spacing">
            <Button
            // onClick={update}
            >
              Update
            </Button>
          </Col>
          <Col className="modal-cancel-button-spacing">
            <Button onClick={onHide} variant="dark">
              Cancel
            </Button>
          </Col>
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
        </Row>
      </Modal>
      {/* <LoadingModal show={loading} /> */}
    </>
  );
}

function EditSStTeam(props) {
  const [modalShow, setModalShow] = useState(false);
  //   const [hospitals, setHospitals] = useState({
  //     id: undefined,
  //     hospital: "",
  //   });
  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        size="lg"
        onClick={() => setModalShow(true)}
      />
      <EditSSTeamModal
        show={modalShow}
        onClick={props.onHide}
        onHide={() => {
          setModalShow(false);
          props.onClose();
        }}
        // hospital={props.hospital}
      />
    </>
  );
}

export default EditSStTeam;
